import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { authGuard } from './guards/auth.guard';
import { permissionGuard } from './guards/permission.guard';

export const routes: Routes = [
    {
        path: 'admin/login',
        title: 'Iniciar Sesión',
        component: LoginComponent
    },
    {
        path: 'admin/dashboard',
        title: 'Dashboard',
        component: DashboardComponent,
        canActivate: [authGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./dashboard/dashboard-main/dashboard-main').then(m => m.DashboardMainComponent)
            },
            {
                path: 'welcome',
                loadComponent: () => import('./dashboard/dashboard-welcome/dashboard-welcome').then(m => m.DashboardWelcomeComponent)
            },
            {
                path: 'inventario',
                title: 'Inventario',
                loadChildren: () => import('./inventory/inventory-module').then(m => m.InventoryModule)
            },
            {
                path: 'usuario',
                title: 'Usuarios',
                loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
            },
            {
                path: 'habitacion',
                title: 'Habitaciones',
                loadChildren: () => import('./rooms/rooms.module').then(m => m.RoomsModule)
            },
            {
                path: 'huesped',
                title: 'Huéspedes',
                loadChildren: () => import('./guests/guests.module').then(m => m.GuestsModule)
            },
            {
                path: 'ventas',
                title: 'Ventas',
                loadChildren: () => import('./sales/sales.routes').then(m => m.SALES_ROUTES)
            },
            {
                path: 'reservacion',
                title: 'Reservaciones',
                loadChildren: () => import('./bookings/bookings.module').then(m => m.BookingsModule)
            },
            {
                path: 'facturacion',
                title: 'Facturación',
                loadChildren: () => import('./invoicing/invoicing.routes').then(m => m.INVOICING_ROUTES)
            },
            {
                path: 'limpieza',
                title: 'Limpieza',
                loadComponent: () => import('./cleaning/cleaning-task-board/cleaning-task-board.component').then(m => m.CleaningTaskBoardComponent)
            },
            {
                path: 'complaints',
                canActivate: [permissionGuard('manage_complaints')],
                children: [
                    {
                        path: '',
                        title: 'Reclamos',
                        loadComponent: () => import('./complaints/complaint-list/complaint-list').then(m => m.ComplaintListComponent)
                    },
                    {
                        path: ':id',
                        title: 'Detalle de Reclamo',
                        loadComponent: () => import('./complaints/complaint-detail/complaint-detail').then(m => m.ComplaintDetailComponent)
                    }
                ]
            }
        ]
    },
    {
        path: '',
        redirectTo: '/admin/login',
        pathMatch: 'full'
    }
];

